<template>
<v-card class="admin_secondary" >
  <v-card-title class="secondary white--text">
    {{$store.state.account.account.name}}

  </v-card-title>
  <div class="">
    <v-list class="admin_secondary" dark>
      <template v-for="(item,i) in menu">
            <v-list-group  :key="'c'+i" v-if="item.children" >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{item.title}}</v-list-item-title>
                            </v-list-item-content>
                </template>
      <v-list-item v-for="(child, i) in item.children" :key="i" link :to="child.to" exact>
        <v-list-item-title v-text="child.title"></v-list-item-title>
        <v-list-item-icon>
          <v-icon>{{ child.icon }}</v-icon>
        </v-list-item-icon>
      </v-list-item>
      </v-list-group>
      <v-list-item link :key="'s'+i" v-else :to="item.to" exact>
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </template>


    </v-list>
    <v-divider class="mt-2"></v-divider>
    <div class="secondary pa-4">
      <v-btn block color="primary" @click="$store.commit('account/logout')">Logout</v-btn>
    </div>
  </div>
</v-card>
</template>
<script>
import admin_menu from "@/assets/admin_menu.json"
export default {
  name: "",
  data: () => ({
    menu: admin_menu
  })
}
</script>
<style lang="scss" scoped>
</style>
